import ExceptionPage from "../../components/exception-page/ExceptionPage";

function NoAccess() {
    return (
        <ExceptionPage title={'Access Denied'} description={"Looks like you're not authorized to access information on this page. \n If you need access to specific content please contact your Manager."}/>
    );
}

export default NoAccess;